import React from "react";
import { styles } from "./leadsStyles";

export function LeadsRdStationTab({ vm }) {
  const {
    rdStationMessage,
    rdStationStatus,
    rdStationApiToken,
    setRdStationApiToken,
    rdStationConversionId,
    setRdStationConversionId,
    saveRdStationConfig,
    testRdStation,
    removeRdStationConfig,
  } = vm;
  return (
              <div style={styles.webhookContainer}>
                <h3 style={styles.sectionTitle}>Integração com RD Station</h3>
                <p style={styles.webhookDescription}>
                  Configure a integração com o RD Station para enviar automaticamente seus leads para a plataforma.
                </p>
                
                {rdStationMessage && (
                  <div style={{
                    ...styles.message,
                    ...(rdStationStatus === "success" ? styles.messageSuccess : styles.messageError)
                  }}>
                    {rdStationMessage}
                  </div>
                )}
                
                <div style={styles.formGroup}>
                  <label style={styles.label}>Token da API do RD Station:</label>
                  <input
                    type="text"
                    value={rdStationApiToken}
                    onChange={(e) => setRdStationApiToken(e.target.value)}
                    placeholder="Digite o token de acesso à API do RD Station"
                    style={styles.input}
                  />
                  <p style={styles.helperText}>
                    O token de API pode ser obtido nas configurações da sua conta RD Station.
                  </p>
                </div>
                
                <div style={styles.formGroup}>
                  <label style={styles.label}>Identificador de Conversão (opcional):</label>
                  <input
                    type="text"
                    value={rdStationConversionId}
                    onChange={(e) => setRdStationConversionId(e.target.value)}
                    placeholder="neurobot-lead"
                    style={styles.input}
                  />
                  <p style={styles.helperText}>
                    Identificador usado para agrupar conversões no RD Station. Padrão: "neurobot-lead"
                  </p>
                </div>
                
                <div style={styles.buttonGroup}>
                  <button onClick={saveRdStationConfig} style={styles.button}>
                    Salvar Configuração
                  </button>
                  <button onClick={testRdStation} style={styles.buttonSecondary}>
                    Testar Conexão
                  </button>
                  <button onClick={removeRdStationConfig} style={styles.buttonDanger}>
                    Excluir integração
                  </button>
                </div>
              </div>
  );
}
